import { useLocation } from "react-router-dom";
import { t } from "@lingui/core/macro";
import { TopNavigation, TopNavigationItems } from "@fidelix/fx-miranda";
import { NavMenu } from "../../topnavi/nav-menu";
import {
  DEVICES_ADMIN_OVERVIEW,
  IP_SETTINGS_OVERVIEW,
  NORMALIZATION_OVERVIEW,
} from "../../routes/route-paths";
import { featureFlags } from "../../feature-flag/feature-flag.utils";

type NavigationItem = TopNavigationItems[number] & { isHidden?: boolean };

export default function ManageNavbar() {
  const { pathname } = useLocation();

  const isRouteActive = (routeTo: string): boolean => {
    const parts = pathname.split("/");
    const routeParts = routeTo.split("/");
    return parts[2] === routeTo || parts[2] === routeParts[2];
  };

  const routes: NavigationItem[] = [
    {
      label: t`Normalization`,
      to: NORMALIZATION_OVERVIEW,
      isActive: isRouteActive("normalization"),
    },
    {
      label: t`IP Settings`,
      to: IP_SETTINGS_OVERVIEW,
      isActive: isRouteActive("network"),
      isHidden: !featureFlags.isFeatureEnabled("IP Settings"),
    },
    {
      label: t`Devices`,
      to: DEVICES_ADMIN_OVERVIEW,
      isActive: isRouteActive("devices"),
    },
  ];

  return (
    <TopNavigation variant="secondary">
      <TopNavigation.Logo text="Assets" menuItems={[]} />
      <TopNavigation.Items items={routes.filter((r) => !r.isHidden)} />
      <NavMenu id="Admin" />
    </TopNavigation>
  );
}
